<form [formGroup]="chargesForm" class="charge-list mt-3" #chargeList>
  <div formArrayName="charges">
    <ng-container *ngFor="let charge of charges.controls; let i = index">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="0.5em" class="mt-2" [formGroup]="charge">
        <mat-form-field
          *ngIf="(pbEnabled$ | async) && (hbEnabled$ | async)"
          subscriptSizing="dynamic"
          fxFlex="75px"
          hideRequiredMarker>
          <mat-label> {{ 'charges-table.form.pricing' | translate }}</mat-label>
          <mat-select
            formControlName="type"
            (selectionChange)="onItemTypeSelected($event.value, i)"
          >
            <mat-option
              [value]="ChargeDescriptionMaster.TYPE.HB"
              *ngIf="(hbEnabled$ | async) || charges.at(i).get('type').value === ChargeDescriptionMaster.TYPE.HB"
            >
              {{ ChargeDescriptionMaster.TYPE.HB.toUpperCase() }}
            </mat-option>
            <mat-option
              [value]="ChargeDescriptionMaster.TYPE.PB"
              *ngIf="(pbEnabled$ | async) || charges.at(i).get('type').value === ChargeDescriptionMaster.TYPE.PB"
            >
              {{ ChargeDescriptionMaster.TYPE.PB.toUpperCase() }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" fxFlex hideRequiredMarker>
          <mat-label> {{ 'charges-table.form.description' | translate }}</mat-label>
          <mat-select
            formControlName="description"
            (selectionChange)="onItemSelected($event.value, i)"
            *ngIf="!charges.at(i).get('description').disabled"
          >
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'charges-table.form.description' | translate"
                [noEntriesFoundLabel]="'charges-table.form.not-found' | translate"
                [searching]="loading$ | async"
                [formControl]="filterDescCtrl"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let charge of filteredCdm$ | async"
              [disabled]="loading$ | async"
              [value]="charge"
            >
              {{ charge.chargeDescription }}
            </mat-option>
          </mat-select>
          <input matInput formControlName="description" *ngIf="charges.at(i).get('description').disabled">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" fxFlex="12" hideRequiredMarker>
          <mat-label> {{ 'charges-table.form.cpt' | translate }}</mat-label>
          <mat-select
            formControlName="cptCode"
            (selectionChange)="onItemSelected($event.value, i)"
            *ngIf="!charges.at(i).get('cptCode').disabled"
          >
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'charges-table.form.cpt' | translate"
                [noEntriesFoundLabel]="'charges-table.form.not-found' | translate"
                [searching]="loading$ | async"
                [formControl]="filterCptCtrl"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let charge of filteredCdm$ | async"
              [disabled]="loading$ | async"
              [value]="charge"
            >
              {{ charge.cptCode }} - {{ charge.chargeDescription }}
            </mat-option>
          </mat-select>
          <input matInput formControlName="cptCode" *ngIf="charges.at(i).get('cptCode').disabled">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" fxFlex="12" hideRequiredMarker>
          <mat-label> {{ 'charges-table.form.modifiers' | translate }}</mat-label>
          <input matInput formControlName="modifiers" placeholder="26,50,TC">
        </mat-form-field>

        <ng-container *ngIf="(hbEnabled$ | async)">
          <mat-form-field subscriptSizing="dynamic" fxFlex="12" hideRequiredMarker *appHasPermission="'appointment.estimate.rev-code.view'">
            <mat-label> {{ 'charges-table.form.rev-code' | translate }}</mat-label>
            <input matInput formControlName="revCode">
          </mat-form-field>
        </ng-container>

        <mat-form-field subscriptSizing="dynamic" fxFlex="75px" hideRequiredMarker>
          <mat-label>{{ 'charges-table.form.units' | translate }}</mat-label>
          <input matInput formControlName="quantity" type="number" min="1">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" fxFlex="110px" hideRequiredMarker>
          <mat-label>{{ 'charges-table.form.visit-number' | translate }}</mat-label>
          <input matInput formControlName="visitNumbers" required placeholder="1-3,5">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="no-display" fxFlex="100px" hideRequiredMarker>
          <mat-label>{{ 'charges-table.form.facility' | translate }}</mat-label>
          <input matInput formControlName="facilityId">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="no-display" hideRequiredMarker *appHasPermission="'appointment.estimate.charge.view'">
          <mat-label> {{ 'charges-table.form.unit-charge' | translate }}</mat-label>
          <input matInput formControlName="unitCharge">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic" class="no-display" fxFlex="12" hideRequiredMarker *appHasPermission="'appointment.estimate.charge.view'">
          <mat-label> {{ 'charges-table.form.total-charge' | translate }}</mat-label>
          <input matInput formControlName="totalCharge">
        </mat-form-field>

        <div>
          <ng-container *ngIf="currentlyEditingIndex === i; else editButton">
            <button mat-icon-button color="warn" (click)="cancelEditEstimateItem(i)">
              <mat-icon>cancel</mat-icon>
            </button>
          </ng-container>
          <ng-template #editButton>
            <button mat-icon-button color="primary" (click)="editEstimateItem(i)" [disabled]="currentlyEditingIndex || !charges.at(i).get('cptCode').value">
              <mat-icon>edit</mat-icon>
            </button>
          </ng-template>
          <button mat-icon-button color="warn" (click)="removeEstimateItem(i)" [disabled]="currentlyEditingIndex">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</form>
<div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="0.5em" class="mt-3 text-bold">
  <!-- <span>{{ 'common.total' | translate }}: </span> -->
  <!-- <span class="ml-2">{{ total$ | async | currency: 'USD' }}</span> -->
</div>
<div fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="1rem" class="mt-3">
  <button
    *ngIf="hbEnabled$ | async"
    mat-flat-button
    color="primary"
    [disabled]="(chargesForm.invalid && charges.length > 0) || currentlyEditingIndex"
    [matTooltip]="'charges-table.form.add-charge' | translate"
    (click)="addEstimateItem('hb')"
  >
    <mat-icon>add</mat-icon>
    Add HB Charge
  </button>

  <ng-container *ngIf="pbEnabled$ | async">
    <mat-form-field *ngIf="hbEnabled$ | async" appearance="outline" subscriptSizing="dynamic">
      <mat-label>PB Facility</mat-label>
      <mat-select [(ngModel)]="pbFacilityId">
        <mat-option *ngFor="let facility of pbFacilities$ | async" [value]="facility.id">{{ facility.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      [disabled]="((hbEnabled$ | async) && !pbFacilityId) || (chargesForm.invalid && charges.length > 0) || currentlyEditingIndex"
      [matTooltip]="'charges-table.form.add-charge' | translate"
      (click)="addEstimateItem('pb')"
    >
      <mat-icon>add</mat-icon>
      Add PB Charge
    </button>
  </ng-container>
</div>
